import ApiProfile from './api.profile';
import ApiTfa from './api.tfa';

declare var firebase;
declare var location;

class AuthService {

  constructor() {
    const userData = localStorage.getItem('userData');
    const registerData = localStorage.getItem('registerData');
    this.isLogged = false;
    this.service = new ApiProfile();
    this.currentUser = {};
    this.registerData = {};

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        localStorage.setItem('registerData', JSON.stringify(user));
        this.registerData = user;
        this.emit('firebaseLogin', { registerData: user });
        if (userData) {
          this.saveProfileLocal(JSON.parse(userData));
        } else {
          this.refresh();
        }
      }
    });

    if (userData && registerData) {
      this.currentUser = JSON.parse(userData);
      this.registerData = JSON.parse(registerData);
      this.refresh();
    }

    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.refresh = this.refresh.bind(this);
    this.create = this.create.bind(this);
    this.emit = this.emit.bind(this);
    this.update = this.update.bind(this);
    this.saveProfileLocal = this.saveProfileLocal.bind(this);
  }

  login() {
    let provider = new firebase.auth.GoogleAuthProvider();
    provider.addScope('https://www.googleapis.com/auth/plus.login');
    firebase.auth().useDeviceLanguage();

    firebase.auth().signInWithPopup(provider).then(user => {
      localStorage.setItem('registerData', JSON.stringify(user));
      this.registerData = user;
      this.refresh();

    }, (err) => {
      if (err.code !== 'auth/cancelled-popup-request') {

        this.emit('messageModal', { title: 'Login Fail', message: err.message });

      }
    });
  }

  logout() {
    firebase.auth().signOut().then(() => {
      window.localStorage.removeItem('userData');
      window.localStorage.removeItem('registerData');
      window.localStorage.removeItem('token');
      window.localStorage.clear();
      this.profile = {};
      this.currentUser = {};
      this.registerData = {};

      let data = {
        registerData: {},
        profile: {}
      };


      this.currentUser = {};
      this.registerData = {};

      if (window.location.href.includes('profile')) {
        window.location.href = window.location.origin;
      } else {
        window.location.reload();
      }

      this.emit('profileLogout', data);
    }, (error) => {
      this.emit('messageModal', {
        title: 'Logout Fail',
        message: 'Something wrong happened with your logout... We are checking...'
      });
    });
  }

  update(profile, type) {
    return new Promise((resolve, reject) => {
      if (type && type == 'tfa' && profile.tfa) {
        profile['tfa_token'] = profile.tfa.token;
      }
      new ApiProfile().put(profile).then(response => {
        this.saveProfileLocal(profile);
        resolve(response.data);
      }).catch(() => {
        reject();
      });
    });

  }

  refresh() {
    if (this.registerData.uid) {
      new ApiProfile().getProfile().then(response => {
        let profile = response.data;
        if (profile) {
          if (!profile.tfa_active) {
            new ApiTfa().get().then(res => {
              if (res.data) {
                const tfa = res.data;
                profile.tfa = tfa;
                this.saveProfileLocal(profile);
              }
            });
          } else { this.saveProfileLocal(profile) }
        }
      }).catch(err => {
        let register = {
          name: this.registerData.displayName,
          email: this.registerData.email
        };
        if (err.response && err.response.status === 403) {
          this.create(register);
        }
      });
    }
  }

  create(profile) {
    new ApiProfile().createProfile(profile).then(response => {
      if (response.data) {
        localStorage.setItem('userData', JSON.stringify(response.data));
        response.data.reserved_auction = 0;
        this.saveProfileLocal(response.data)
      }
    }).catch(err => {
      console.log(err);
    });
  }

  emit(eventName, data) {
    let event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
  }

  saveProfileLocal(profile) {
    if (profile.btc_funds <= 0) { profile.btc_funds = 0; }
    profile.asset_balance = 0;
    if (profile.lander_current_properties && profile.lander_current_properties.lenght) {
      profile.lander_current_properties.forEach(e => {
        profile.asset_balance += e.info.previous_landers[0].previous_lander_asset_price * 1.2;
      });
    }
    this.currentUser = profile;
    let profileStringfy = JSON.stringify(profile);
    localStorage.setItem('userData', profileStringfy);
    let data = {
      registerData: this.registerData,
      profile: profile
    };
    this.emit('profileLoaded', data);
  }
}

export default new AuthService();


// WEBPACK FOOTER //
// ./src/utils/auth.service.js